// extracted by mini-css-extract-plugin
module.exports = {"filtered-widget__container":"filtered-widget_filtered-widget__container__3lw_y"};